import React, { useEffect } from 'react';
import { Routes } from 'routing';
import { useLocation } from 'react-router-dom';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <Routes />;
}

export default App;
